import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { EcaEnvironmentService } from '../environment/environment.service';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class EcaJwtInterceptor implements HttpInterceptor {
  private _ecaEnvironmentService = inject(EcaEnvironmentService);
  private _jwtHelper = inject(JwtHelperService);

  headerName = 'Authorization';
  authScheme = 'Bearer ';

  private getWhitelistedDomains(): Array<string | RegExp> {
    const environment = this._ecaEnvironmentService.json;
    const whitelistedDomains = [];

    whitelistedDomains.push(environment['apiGatewayUrl']);

    _.forEach(environment['apiGatewayExceptions'], (domain) => {
      whitelistedDomains.push(domain);
    });

    return whitelistedDomains;
  }

  isWhitelistedDomain(request: HttpRequest<any>): boolean {
    let requestUrl: URL;
    try {
      requestUrl = new URL(request.url);
      return (this.getWhitelistedDomains().indexOf(requestUrl.host) > -1);
    } catch {
      // if we're here, the request is made
      // to the same domain as the Angular app
      // so it's safe to proceed
      return true;
    }
  }

  handleInterception(token: string, request: HttpRequest<any>, next: HttpHandler) {
    const tokenIsExpired: boolean = !token || this._jwtHelper.isTokenExpired(token);

    if (token && tokenIsExpired) {
      request = request.clone();
    } else if (token && this.isWhitelistedDomain(request)) {
      request = request.clone({
        setHeaders: {
          [this.headerName]: `${this.authScheme}${token}`
        }
      });
    }
    return next.handle(request);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token: any = this._jwtHelper.tokenGetter();
    return this.handleInterception(token, request, next);
  }
}

export const ECA_JWT_HTTP_INTERCEPTOR_PROVIDER = {
  provide: HTTP_INTERCEPTORS,
  useClass: EcaJwtInterceptor,
  multi: true
};
